export default __webpack_public_path__ + "static/media/prizeIcon3.3650d08d.png";